class MiniQuizModal extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.closeButtons = this.querySelectorAll('[data-close-modal]');
    this.quizForm = this.querySelector('#mini-quiz-form');
    this.recommendationView = this.querySelector('.mini-quiz__recommendation');
    this.questionsView = this.querySelector('.mini-quiz__questions');
    this.seeRecommendationBtn = this.querySelector('#see-recommendation-btn');
    this.subscribeBtn = this.querySelector('#mini-quiz-subscribe-btn');
    
    // Bind events
    this.closeButtons.forEach(btn => btn.addEventListener('click', this.close.bind(this)));
    this.quizForm.addEventListener('change', this.onFormChange.bind(this));
    this.seeRecommendationBtn.addEventListener('click', this.showRecommendation.bind(this));
    this.subscribeBtn.addEventListener('click', this.addToCart.bind(this));
    
    // Close on click outside (backdrop click)
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.close();
      }
    });
  }

  open() {
    this.dialog.showModal();
    this.reset();
  }

  close() {
    this.dialog.close();
  }

  reset() {
    this.quizForm.reset();
    this.questionsView.style.display = 'block';
    this.recommendationView.style.display = 'none';
    this.seeRecommendationBtn.disabled = true;
  }

  onFormChange() {
    const formData = new FormData(this.quizForm);
    const dogs = formData.get('dogs');
    const walks = formData.get('walks');
    const frequency = formData.get('frequency');
    
    if (dogs && walks && frequency) {
      this.seeRecommendationBtn.disabled = false;
    }
  }

  showRecommendation(e) {
    if (e) e.preventDefault();
    try {
      console.log("showRecommendation clicked");
      const formData = new FormData(this.quizForm);
      const dogs = parseInt(formData.get('dogs'));
      const walks = parseInt(formData.get('walks'));
      const frequency = formData.get('frequency');
      
      console.log("Form data:", { dogs, walks, frequency });
      
      // Logic Mapping based on User's Table
      let recommendedVariant = '105';
      let bagsCount = 105;
      let rollsCount = 7;
      
      if (dogs >= 3) {
        recommendedVariant = '420';
        bagsCount = 420;
        rollsCount = 28;
      } else if (dogs === 2) {
        if (walks === 1) {
          if (frequency === 'topped_up') {
            recommendedVariant = '210'; bagsCount = 210; rollsCount = 14;
          } else {
            recommendedVariant = '420'; bagsCount = 420; rollsCount = 28;
          }
        } else {
          // walks >= 2
          recommendedVariant = '420'; bagsCount = 420; rollsCount = 28;
        }
      } else if (dogs === 1) {
        if (walks === 1) {
          if (frequency === 'topped_up') {
            recommendedVariant = '105'; bagsCount = 105; rollsCount = 7;
          } else {
            recommendedVariant = '210'; bagsCount = 210; rollsCount = 14;
          }
        } else if (walks === 2) {
          if (frequency === 'topped_up') {
            recommendedVariant = '210'; bagsCount = 210; rollsCount = 14;
          } else {
            recommendedVariant = '420'; bagsCount = 420; rollsCount = 28;
          }
        } else {
          // walks >= 3
          recommendedVariant = '420'; bagsCount = 420; rollsCount = 28;
        }
      }
      
      // Frequency mapping
      let frequencyText = 'EVERY 1 MONTH';
      let loopFrequencyValue = '1';
      let loopFrequencyUnit = 'Month';
      
      if (frequency === 'few_months') {
        frequencyText = 'EVERY 2 MONTHS';
        loopFrequencyValue = '2';
        loopFrequencyUnit = 'Months';
      } else if (frequency === 'rarely') {
        frequencyText = 'EVERY 4 MONTHS';
        loopFrequencyValue = '4';
        loopFrequencyUnit = 'Months';
      }
      
      // Update Recommendation UI
      this.querySelector('.mini-quiz__rec-variant').innerHTML = `${bagsCount} BAGS (${rollsCount} ROLLS &times; 15 BAGS)`;
      this.querySelector('.mini-quiz__rec-frequency').textContent = frequencyText;

      // Store the recommended values for add to cart
      this.recommendedVariant = recommendedVariant;
      this.loopFrequencyValue = loopFrequencyValue;
      this.loopFrequencyUnit = loopFrequencyUnit;

      this.questionsView.style.display = 'none';
      this.recommendationView.style.display = 'flex';
      console.log("Recommendation view shown");
    } catch (err) {
      console.error("Error in showRecommendation:", err);
    }
  }

  addToCart() {
    // Show loading state
    const originalText = this.subscribeBtn.innerHTML;
    this.subscribeBtn.innerHTML = '<span class="mini-quiz-spinner"></span> ADDING...';
    this.subscribeBtn.disabled = true;

    // 1. Select the variant
    const variantInputs = document.querySelectorAll('.custom-variant-fieldset input[type="radio"]');
    variantInputs.forEach(input => {
      if (input.value.includes(this.recommendedVariant)) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 2. Wait for Loop to re-render after variant change
    setTimeout(() => {
      // Find the active variant ID
      const variantFormInput = document.querySelector('product-form-component input[name="id"]');
      const activeVariantId = variantFormInput ? variantFormInput.value : '';

      // Make sure subscription is selected for the active variant
      const subRadio = activeVariantId 
        ? document.querySelector(`.loop-subscription-group-radio[data-variant-id="${activeVariantId}"]`)
        : document.querySelector('.loop-subscription-group-radio');
        
      if (subRadio && !subRadio.checked) {
        subRadio.click();
      }
      
      // Select the frequency from the dropdown for the active variant only
      let selectSelector = '.loop-selling-plan-selector';
      if (activeVariantId) {
        selectSelector = `select[id^="loop-select-${activeVariantId}"]`;
      }
      
      const loopSelects = document.querySelectorAll(selectSelector);
      loopSelects.forEach(select => {
        // Iterate options
        Array.from(select.options).forEach(option => {
          const optText = option.text.toLowerCase();
          const valText = this.loopFrequencyValue.toLowerCase();
          const unitText = this.loopFrequencyUnit.toLowerCase();
          
          let isMatch = false;
          if (valText === '1') {
            // "Deliver every month" doesn't have the number 1 in it
            if ((optText.includes('1') || !optText.match(/\d/)) && optText.includes(unitText)) {
              isMatch = true;
            }
          } else {
            if (optText.includes(valText) && optText.includes(unitText)) {
              isMatch = true;
            }
          }
          
          if (isMatch) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            
            // SUPER BULLETPROOF: Manually set the selling plan hidden input right now
            const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
            if (sellingPlanInput) {
               sellingPlanInput.value = option.value;
            }
            
            // Also update the custom UI span if it exists
            const idParts = select.id.replace('loop-select-', '');
            const selectedSpan = document.getElementById('custom-loop-dropdown-selected-' + idParts);
            if (selectedSpan) {
              selectedSpan.textContent = option.text;
            }
          }
        });
      });

      // 3. Click Add to Cart
      setTimeout(() => {
        const addToCartBtn = document.querySelector('.custom-featured-product__add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.click();
        }
        
        // Close modal and reset button state
        this.close();
        this.subscribeBtn.innerHTML = originalText;
        this.subscribeBtn.disabled = false;
      }, 400);
      
    }, 800);
  }
}

if (!customElements.get('mini-quiz-modal')) {
  customElements.define('mini-quiz-modal', MiniQuizModal);
}
